import { render, staticRenderFns } from "./initiateStocking.vue?vue&type=template&id=f0326ae0&scoped=true"
import script from "./initiateStocking.vue?vue&type=script&lang=js"
export * from "./initiateStocking.vue?vue&type=script&lang=js"
import style0 from "./initiateStocking.vue?vue&type=style&index=0&id=f0326ae0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0326ae0",
  null
  
)

export default component.exports